export const libHelperName = {
	addElement: "___addElement",
	createElement: "___createElement",
	createElementNS: "___createElementNS",
	createConditionalElement: "___createConditionalElement",
	createConditionalElementNS: "___createConditionalElementNS",
	createMultiElement: "___createMultiElement",
	createMultiElementNS: "___createMultiElementNS",
	createTextNode: "___createTextNode",
	createExpressionTextNode: "___createExpressionTextNode",
	addAttribute: "___addAttribute",
	addAttributes: "___addAttributes",
	addProperty: "___addProperty",
	addCustomAttribute: "___addCustomAttribute",
	addProperties: "___addProperties",
	addRef: "___addRef",
	addListener: "___addListener",
	addListeners: "___addListeners",
	addShadowRoot: "___addShadowRoot",
	attributeChanged: "___attributeChanged",
	bootstrap: "___bootstrap",
	connectCustomElement: "___connectCustomElement",
	connectCustomAttribute: "___connectCustomAttribute",
	connectTemplates: "___connectTemplates",
	connectCSS: "___connectCSS",
	connectProps: "___connectProps",
	connectListeners: "___connectListeners",
	connectVisibilityObservers: "___connectVisibilityObservers",
	connectChildListObservers: "___connectChildListObservers",
	connectAttributeChangeObservers: "___connectAttributeChangeObservers",
	connectHostAttributes: "___connectHostAttributes",
	dispose: "___dispose",
	disposeProps: "___disposeProps",
	disposeListeners: "___disposeListeners",
	disposeVisibilityObservers: "___disposeVisibilityObservers",
	disposeCSS: "___disposeCSS",
	disposeTemplates: "___disposeTemplates",
	disposeChildListObservers: "___disposeChildListObservers",
	disposeAttributeChangeObservers: "___disposeAttributeChangeObservers",
	disposeHostAttributes: "___disposeHostAttributes",
	destroy: "___destroy",
	destroyTemplates: "___destroyTemplates",
	registerStaticTemplate: "___registerStaticTemplate",
	useStaticTemplate: "___useStaticTemplate",
	registerProp: "___registerProp",
	registerSetOnHost: "___registerSetOnHost",
	mapPropertiesToAttributes: "___mapPropertiesToAttributes",
	registerElement: "___registerElement",
	registerCustomAttribute: "___registerCustomAttribute",
	registerListener: "___registerListener",
	registerChangeObserver: "___registerChangeObserver",
	registerAttributeChangeObserver: "___registerAttributeChangeObserver",
	registerVisibilityObserver: "___registerVisibilityObserver",
	registerChildListObserver: "___registerChildListObserver",
	constructCustomAttribute: "___constructCustomAttribute",
	constructCustomElement: "___constructCustomElement",
	registerEmitter: "___registerEmitter",
	registerStaticCSS: "___registerStaticCSS",
	useStaticCSS: "___useStaticCSS",
	use: "___use",
	dependsOn: "___dependsOn",
	registerHostAttributes: "___registerHostAttributes"
};

export declare type LibHelperName = keyof typeof libHelperName;